import mainView from './static/templates/main.view.html';
import trackingResultsView from './static/templates/results.view.html';
import mainViewController from './controllers/main-view.controller';

function routeConfig($routeProvider) {

  $routeProvider
    .when('/', {
      template: mainView,
      controller: mainViewController,
      controllerAs: 'vm'
    })
    .when('/tracking-results/:number?', {
      template: trackingResultsView,
      resolve: {
        trackingResults: ($route, routeService) => routeService.handleRequest($route)
      }
    })
    .when('/tracking-results/:number?/:mac?', {
      template: trackingResultsView,
      resolve: {
        trackingResults: ($route, routeService) => routeService.handleNotification($route)
      }
    })
    .otherwise({
      redirectTo: '/'
    });

}

export default routeConfig;



// WEBPACK FOOTER //
// ./src/main.route.js